const {
  callAuthorizedGraphQLEndpoint,
} = require('../../../../../Module/graphQL')

const getClientCodesInfo = queryVars => {
  const query = `query (
    $campaignId:ID!
  ) {
    campaignClientCodes(campaignId: $campaignId) {
      trackingType
      campaignId
      clientCodes{
        id
        clientCode
        clientLink
        city{
          id
          name
        }
      }
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, queryVars)
}

export { getClientCodesInfo }
